import BillingReport from './billing-report.endpoint.constants';
import Clarity from './clarity-result.endpoint.constants';
import Comment from './comment.endpoint.constants';
import Company from './company.endpoint.constants';
import CoolantSample from './coolant-sample.endpoint.constants';
import Customer from './customer.endpoint.constants';
import CoolantFileUpload from './file-upload-coolant.endpoint.constants';
import OilFileUpload from './file-upload-oil.endpoint.constants';
import Fluid from './fluid.endpoint.constants';
import FluidManufacturer from './fluid-manufacturer.endpoint.constants';
import FluidBrand from './fluid-brand.endpoint.constants';
import FluidClass from './fluid-class.endpoint.constants';
import FluidWeight from './fluid-weight.endpoint.constants';
import FluidBaselineSample from './fluid-baseline-sample.endpoint.constants';
import FluidAction from './fluid-action.endpoint.constants';
import ManufacturerModel from './manufacturer-model.endpoint.constants';
import OilResult from './oil-result.endpoint.constants';
import OilSample from './oil-sample.endpoint.constants';
import Precipitate from './precipitate-result.endpoint.constants';
import ThirdParty from './third-party.endpoint.constants';
import Severity from './severity.endpoint.constants';
import Unit from './unit.endpoint.constants';
import UnitOfMeasure from './unit-of-measure.endpoint.constants';
import UnitType from './unit-type.endpoint.constants';
import User from './user.endpoint.constants';

export default {
  BillingReport,
  Clarity,
  Comment,
  Company,
  CoolantSample,
  Customer,
  CoolantFileUpload,
  OilFileUpload,
  Fluid,
  FluidManufacturer,
  FluidBrand,
  FluidClass,
  FluidWeight,
  FluidBaselineSample,
  FluidAction,
  ManufacturerModel,
  OilResult,
  OilSample,
  Precipitate,
  Severity,
  ThirdParty,
  Unit,
  UnitOfMeasure,
  UnitType,
  User
};
